import { Injectable } from '@angular/core';
@Injectable()
export class LogService {

    public static readonly DEBUG = 1000;
    public static readonly INFO = 2000;
    public static readonly WARNING = 3000;
    public static readonly ERROR = 4000;
    public static readonly FATAL = 5000;


    private level: number = LogService.INFO;
    private name = '';

    constructor() {
    }

    setLevel(level: number): void {
        if ([LogService.DEBUG, LogService.INFO, LogService.WARNING, LogService.ERROR, LogService.FATAL].indexOf(level) < 0) {
            throw new Error('DEBUGGING LEVEL NOT PERMITED');
        }

        console.log('Log level set to: ', level);

        this.level = level;
    }

    setName(name: string): LogService {
        this.name = name;
        return this;
    }

    private log(level: string, msg: any, raw: boolean = false): void {
        let callerName = JSON.parse(JSON.stringify(this.name));
        if (this.name === '') {
            const stackTrace = (new Error()).stack; // Only tested in latest FF and Chrome
            callerName = stackTrace.replace(/^Error\s+/, ''); // Sanitize Chrome
            callerName = callerName.split('\n')[2]; // 1st item is this, 2nd item is caller in this class, 3rd is the caller
            callerName = callerName.replace(' [angular]', ''); // Take out angular
            callerName = callerName.replace(/^\s+at Object./, '');
            callerName = callerName.replace(/^\s+at new./, '');
            callerName = callerName.replace(/^\s+at ([^.]*).*$/, '$1');
            callerName = callerName.replace(/ \(.+\)$/, ''); // Sanitize Chrome
            callerName = callerName.replace(/@.+/, ''); // Sanitize Firefox
            if (callerName.indexOf(':') > -1 || callerName.indexOf('SafeSubscriber') > -1) {
                callerName = '';
            }
        }
        // this.name = '';

        const date = new Date();
        const stringDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate())).slice(-2) + ' ' + ('0' + date.getHours() ).slice(-2) + ':' + ('0' + date.getMinutes() ).slice(-2) + ':' + ('0' + date.getSeconds() ).slice(-2);

        let data = msg;
        if (!raw) { data = JSON.stringify(msg); }



        if (level === 'debug') {
          console.group(callerName);
        } else { console.groupCollapsed(callerName); }

        console[level](stringDate + ': ' + level.toUpperCase() + ' ', data);
        console.groupEnd();
    }

    rawDebug(...msg: any): void {
        let level = LogService.DEBUG;
        if (this !== undefined) {
            level = this.level;
        }
        if (this !== undefined && level <= LogService.DEBUG) {
            this.log('debug', msg, true);
        }
    }

    debug(...msg: any): void {
        let level = LogService.DEBUG;
        if (this !== undefined) {
            level = this.level;
        }
        if (this !== undefined && level <= LogService.DEBUG) {
            this.log('debug', msg);
        }
    }

    info(...msg: any): void {
        let level = LogService.DEBUG;
        if (this !== undefined) {
            level = this.level;
        }
        if (level <= LogService.INFO) {
            this.log('info', msg);
        }
    }

    warn(...msg: any): void {
        let level = LogService.DEBUG;
        if (this !== undefined) {
            level = this.level;
        }
        if (level <= LogService.WARNING) {
            this.log('warn', msg);
        }
    }

    err(...msg: any): void {
        let level = LogService.DEBUG;
        if (this !== undefined) {
            level = this.level;
        }
        if (level <= LogService.ERROR) {
            this.log('error', msg);
        }
    }

    fatal(...msg: any): void {
        let level = LogService.DEBUG;
        if (this !== undefined) {
            level = this.level;
        }
        if (level <= LogService.FATAL) {
            this.log('fatal', msg);
        }
    }
}
